import React from 'react';
import { motion } from 'framer-motion';
import { Accordion } from './Accordion';
const faqData = [{
  id: 'faq-1',
  question: '¿Sirve para cualquier universidad?',
  answer: 'Sí. El contenido está basado en el programa general de Bioquímica, compatible con los planes de estudio de las principales universidades.'
}, {
  id: 'faq-2',
  question: '¿Es solo de Bioquímica o mezcla otras carreras?',
  answer: '100% Bioquímica. Sin contenido de Farmacia ni otras carreras — para que no pagues por algo que no vas a usar.'
}, {
  id: 'faq-3',
  question: '¿Cómo recibo el material?',
  answer: 'Acceso inmediato después del pago. Digital — celular, tablet o computadora. También podés imprimirlo.'
}, {
  id: 'faq-4',
  question: '¿Qué diferencia hay entre las dos ofertas?',
  answer: 'Ambas incluyen los 6 tomos completos. La diferencia está en los bonos: la primera opción trae 4 bonos esenciales, la segunda suma 3 herramientas adicionales para llevar tu organización un paso más allá.'
}, {
  id: 'faq-5',
  question: '¿Sirve si recién empiezo la carrera?',
  answer: 'Sí. El Tomo 1 y 2 están pensados para arrancar desde el ciclo básico, no asumen conocimiento previo.'
}, {
  id: 'faq-6',
  question: '¿Tiene garantía real?',
  answer: 'Sí. 7 días, sin preguntas. Te devolvemos el 100%. Menos del 1% pide devolución.'
}];
export function FAQ() {
  const accordionItems = faqData.map(faq => ({
    id: faq.id,
    title: <span className="text-brand-dark font-bold" data-id="element-68">{faq.question}</span>,
    content: <p className="text-gray-600 text-sm pt-2" data-id="element-69">{faq.answer}</p>
  }));
  return <section className="bg-brand-light py-16 px-4 sm:px-6 lg:px-8" data-id="element-70">
      <div className="max-w-2xl mx-auto" data-id="element-71">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-2xl sm:text-3xl font-bold text-center text-brand-dark mb-10" data-id="element-72">
          Lo que más nos preguntan
        </motion.h2>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} data-id="element-73">
          <Accordion items={accordionItems} className="space-y-3" itemClassName="bg-white border-gray-200 shadow-sm" headerClassName="hover:bg-gray-50" contentClassName="border-gray-100" data-id="element-74" />
        </motion.div>
      </div>
    </section>;
}